import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Dice5 } from "lucide-react";
import { Top100Service } from "../services/Top100Service";
import { TrackData } from "../types/Types";
import { AudioTrack } from "../components/AudioTrack";
import {Toolbar} from "../components/Toolbar";
import "../styles/Top100.css";

export const Top100 = () => {
  const [tracks, setTracks] = useState<TrackData[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const loadTracks = async () => {
      const data = await Top100Service.fetchTop100Tracks();
      setTracks(data);
      setLoading(false);
    };
    loadTracks();
  }, []);

  const handleRandomizeClick = () => {
    const shuffled = [...tracks].sort(() => Math.random() - 0.5);
    setTracks(shuffled);
  };

  return (
    <div className="top100-page-container">
      <Toolbar />

      <div className="top100-content-wrapper">
        <button className="top100-back-btn" onClick={() => navigate(-1)}>
          <ChevronLeft size={20} />
          Back
        </button>

        <div className="top100-banner">
          <h1 className="top100-name"><span className='top100-augio-logo'>AUGIO</span> TOP 100</h1>
          <p className="top100-description">
            The hottest tracks trending nationwide
          </p>
        </div>

        <button className="top100-randomize-btn" onClick={handleRandomizeClick}>
          <Dice5 size={18} style={{ marginRight: "8px" }} />
          Randomize
        </button>

        {loading ? (
          <div className="top100-loading">Loading Charts...</div>
        ) : (
          <div className="tracks-container">
            {tracks.map((track, index) => (
              <div key={track.id}>
                <AudioTrack track={track} rank={track.rank || index + 1} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
